// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c2b63cae","75":"fbae6428","92":"179615ef","290":"879cb6c7","395":"82f93af0","453":"3b4cebca","522":"acc107a9","751":"953bcf54","820":"42d805e5"}[chunkId] + ".chunk.js";
};